"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.notify.done': 'Gracias por crearme. Dime cómo puedo ayudarte.',
};
